import axios, { AxiosResponse, AxiosError } from "axios";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const storedUserDetails = localStorage.getItem("userdetails");
const token = storedUserDetails ? JSON.parse(storedUserDetails).token.replace(/^"(.*)"$/, '$1') : null;
export const getClients = (
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios
      .get(`${global.api_url}/api/clients_vendors_mapping`, {
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 201){
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else if (error.response?.status === 404){
          _errorCallBack(error.response.data);
        }
        else{
          toast.error("Server Error");
        }
      }
    );
  };
export const getVendorClientWarehouseMapping = (
  client_vendor_id:any,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios
      .get(`${global.api_url}/api/clients_vendors_warehouses?per_page_records=10&page_number=0&client_vendor_id=${client_vendor_id}`, {
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 201){
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else if (error.response?.status === 404){
          _errorCallBack(error.response.data);
        }
        else{
          toast.error("Server Error");
        }
      }
    );
  };
  export const getTrips = (
    per_page_records: number,
    page_number: number,
    from_date: string,
    to_date: string,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
    vehicle_id?: any,
    client_name?:any,
    warehouse_name?:any
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios
      .get(`${global.api_url}/api/get_trips`, {
        params: {
          per_page_records,
          page_number,
          from_date,
          to_date,
          vehicle_id,
          client_name,
          warehouse_name
        },
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 201){
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else if (error.response?.status === 404){
          _errorCallBack(error.response.data);
        }
        else{
          toast.error("Server Error");
        }
      });
  };
  export const getVehicle = (
    per_page_records:number,
    page_number:number,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
    client_name ?: string,
    warehouse_name?:string
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios
      .get(`${global.api_url}/api/vehicles`, {params:{per_page_records, page_number, client_name,warehouse_name},
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 201){
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else if (error.response?.status === 404){
          _errorCallBack(error.response.data);
        }
        else{
          toast.error("Server Error");
        }
      });
  };
  
  export const getFleetCount = (
    from_date:any,
    to_date:any,
    client_id:any,
    warehouse_id:any,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios
      .get(`${global.api_url}/api/dashboard/fleet_count?from_date=${from_date}&to_date=${to_date}&client_id=${client_id}&warehouse_id=${warehouse_id}`, {
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 201){
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          _errorCallBack(error.response);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else if (error.response?.status === 404){
          _errorCallBack(error.response.data);
        }
        else{
          toast.error("Server Error");
        }
      });
  };

  export const getAverageKmPerVehicle = ( from_date:any,
    to_date:any,
    client_id:any, 
    warehouse_id:any,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void) => {
      const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
      const headers = {
        Authorization: `Bearer ${userDetailsFromStorage.token}`
      };
      axios
        .get(`${global.api_url}/api/dashboard/distance?from_date=${from_date}&to_date=${to_date}&client_id=${client_id}&warehouse_id=${warehouse_id}`, {
          headers: headers,
        })
        .then((response: AxiosResponse) => {
          if (response.status === 200) {
            _successCallBack(response.data);
          }
          else if (response.status === 201){
            _successCallBack(response.data);
          }
        })
        .catch((error: AxiosError) => {
          if (error.response?.status === 400) {
            _errorCallBack(error.response.data);
          }
          else if  (error.response?.status === 401){
            localStorage.clear();
          }
          else if (error.response?.status === 404){
            _errorCallBack(error.response.data);
          }
          else{
            toast.error("Server Error");
          }
        });
  }

  export const getTripStatus = ( 
    client_id:any,
    warehouse_id:any,
    fuel_type:any,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void) => {
      const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
      const headers = {
        Authorization: `Bearer ${userDetailsFromStorage.token}`
      };
      axios
        .get(`${global.api_url}/api/dashboard/trip_status?client_id=${client_id}&warehouse_id=${warehouse_id}&fuel_type=${fuel_type}`,{
          headers: headers,
        })
        .then((response: AxiosResponse) => {
          if (response.status === 200) {
            _successCallBack(response.data);
          }
          else if (response.status === 201){
            _successCallBack(response.data);
          }
        })
        .catch((error: AxiosError) => {
          if (error.response?.status === 400) {
            _errorCallBack(error.response.data);
          }
          else if  (error.response?.status === 401){
            localStorage.clear();
          }
          else if (error.response?.status === 404){
            _errorCallBack(error.response.data);
          }
          else{
            toast.error("Server Error");
          }
        });
  }
    export const getWarehouses = (
    page_number: number,
    per_page_records: string | null,
    warehouse_name?: string,
    _successCallBack?: (response: any) => void,
    _errorCallBack?: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage?.token}`,
    };
  
    const params: Record<string, any> = {
      per_page_records: per_page_records ?? "",
      page_number,
    };
    if ( warehouse_name) params.warehouse_name=  warehouse_name;
  
    axios
      .get(`${global.api_url}/api/warehouses`, { headers, params })
      .then((response: AxiosResponse) => {
        if (response.status === 200 || response.status === 201) {
          _successCallBack?.(response.data);
        } else {
          _errorCallBack?.(`Unexpected status code: ${response.status}`);
        }
      })
      .catch((error: AxiosError<any>) => {
        console.log("Error caught:", error);
  
        if (error.response) {
          const { status, data } = error.response;
  
          if (status === 400 || status === 404) {
            _errorCallBack?.(data);
          } else if (status === 401) {
            localStorage.clear();
          } else {
            _errorCallBack?.(`Error ${status}: ${data?.message || "Unknown error"}`);
          }
        } else {
          _errorCallBack?.("Network or server error");
          console.log(error)
        }
      });
  };
  export const getWarehouseCompanyMapping = (
 companies_id:any,
  _successCallBack?: (response: any) => void,
  _errorCallBack?: (errMessage: any) => void,
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage?.token}`,
  };


  axios
    .get(`${global.api_url}/api/warehouses_companies?companies_id=${companies_id}`, { headers })
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack?.(response.data);
      } else {
        _errorCallBack?.(`Unexpected status code: ${response.status}`);
      }
    })
    .catch((error: AxiosError<any>) => {
      console.log("Error caught:", error);

      if (error.response) {
        const { status, data } = error.response;

        if (status === 400 || status === 404) {
          _errorCallBack?.(data);
        } else if (status === 401) {
          localStorage.clear();
        } else {
          _errorCallBack?.(`Error ${status}: ${data?.message || "Unknown error"}`);
        }
      } else {
        _errorCallBack?.("Network or server error");
      }
    });
};
export const dashboardVehicleStatus = (
  successCallBack: (message: string) => void,
  errorCallBack: (errorMessage: string) => void
) => {
  const userDetailsFromStorage = JSON.parse(
    localStorage.getItem("userdetails") || "null"
  );

  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage?.token}`,
    "Content-Type": "text/plain",
  };

  axios
    .post(
      `${global.api_url}/api/dashboard_vehicle_status`,
      {},
      { headers }
    )
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        successCallBack(response.data);
      }
    })
    .catch((error: any) => {
      if (error.response) {
        if (error.response.status === 400) {
          errorCallBack(error.response.data);
        } else if (error.response.status === 401) {
          localStorage.clear();
          toast.error("Login Expired.");
        } else if (error.response.status === 404) {
          errorCallBack(error.response.data);
        }
      } else {
        toast.error("Server Error");
      }
    });
};
export const dashboardFleetCount = (
  mode:any,
  successCallBack: (message: string) => void,
  errorCallBack: (errorMessage: string) => void
) => {
  const userDetailsFromStorage = JSON.parse(
    localStorage.getItem("userdetails") || "null"
  );

  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage?.token}`,
    "Content-Type": "application/json",
  };

  axios
    .post(
      `${global.api_url}/api/dashboard_fleet_count`,
      {mode},
      { headers }
    )
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        successCallBack(response.data);
      }
    })
    .catch((error: any) => {
      if (error.response) {
        if (error.response.status === 400) {
          errorCallBack(error.response.data);
        } else if (error.response.status === 401) {
          localStorage.clear();
          toast.error("Login Expired.");
        } else if (error.response.status === 404) {
          errorCallBack(error.response.data);
        }
      } else {
        toast.error("Server Error");
      }
    });
};
export const dashboardTotalKm = (
  mode: any,
  start_date: any,
  end_date: any,
  fuel_type: any,
  successCallBack: (data: any) => void,
  errorCallBack: (errorMessage: string) => void
) => {
  const userDetailsFromStorage = JSON.parse(
    localStorage.getItem("userdetails") || "null"
  );

  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage?.token}`,
    "Content-Type": "application/json",   
  };

  axios
    .post(
      `${global.api_url}/api/dashboard_total_kms`,
      {
        mode,
        start_date,
        end_date,
        fuel_type,
      },
      { headers }
    )
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        successCallBack(response.data); 
      }
    })
    .catch((error: any) => {
      if (error.response) {
        if (error.response.status === 400) {
          errorCallBack(error.response.data?.message || "Bad Request");
        } else if (error.response.status === 401) {
          localStorage.clear();
          toast.error("Login Expired.");
        } else if (error.response.status === 404) {
          errorCallBack(error.response.data?.message || "Not Found");
        }
      } else {
        toast.error("Server Error");
      }
    });
};
export const getDashboardVehicleCount = (
  fuel_flag:number,
  model_flag:number,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios
      .get(`${global.api_url}/api/dashboard_vehicle_count`, {
        params: {
         fuel_flag,
         model_flag
        },
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 201){
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          _errorCallBack(error.response);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else if (error.response?.status === 404){
          _errorCallBack(error.response.data);
        }
        else{
          toast.error("Server Error");
        }
      });
  };
export const dashboardVehicleSpeed = (
  mode:string,
  from_date:string,
  to_date:string,
  top:number,
  successCallBack: (message: string) => void,
  errorCallBack: (errorMessage: string) => void
) => {
  const userDetailsFromStorage = JSON.parse(
    localStorage.getItem("userdetails") || "null"
  );

  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage?.token}`,
    "Content-Type": "application/json"
  };

  axios
    .post(
      `${global.api_url}/api/dashboard_vehicle_speed`,
      { mode, from_date, to_date, top },
      { headers }
    )
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        successCallBack(response.data);
      }
    })
    .catch((error: any) => {
      if (error.response) {
        if (error.response.status === 400) {
          errorCallBack(error.response.data);
        } else if (error.response.status === 401) {
          localStorage.clear();
          toast.error("Login Expired.");
        } else if (error.response.status === 404) {
          errorCallBack(error.response.data);
        }
      } else {
        toast.error("Server Error");
      }
    });
};